import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OOTSRequestStatus } from '../_model/oots-request-status';
import { OOTSRequestSession } from '../_model/oots-request-session';

const SESSION_API_URL = environment.api_url + "/oots/session";

const headers = new HttpHeaders({
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": environment.api_url,
  "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With, Access-Control-Request-Method, Access-Control-Request-Headers",
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT",
  "Access-Control-Max-Age": "300"
});

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private http: HttpClient) { }

  selectSession(ootsRequestSession: OOTSRequestSession): Observable<any> {
    return this.http.post<any>(SESSION_API_URL + "/select", ootsRequestSession, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  findPreviousSession(uuid: string, userIdentifier: string) {
    const httpParams = new HttpParams()
      .append("uuid", uuid)
      .append("userIdentifier", userIdentifier)
    const httpOptions = {
      headers: headers,
      params: httpParams
    };

    return this.http.get<any>(SESSION_API_URL + "/previous", httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSessionData(uuid: string): Observable<any> {
    const httpParams = new HttpParams().append("uuid", uuid);
    const httpOptions = {
      headers: headers,
      params: httpParams
    };

    return this.http.get<any>(SESSION_API_URL + "/time", httpOptions)
      .pipe(catchError(this.handleError));
  }

  saveOOTSRequestStatus(ootsRequestStatus: OOTSRequestStatus): Observable<any> {
    return this.http.post<any>(SESSION_API_URL + "/status", ootsRequestStatus, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  getOOTSRequestStatus(uuid: string): Observable<any> {
    const httpParams = new HttpParams().append("uuid", uuid);
    const httpOptions = {
      headers: headers,
      params: httpParams
    };

    return this.http.get<any>(SESSION_API_URL + "/status", httpOptions)
      .pipe(catchError(this.handleError));
  }

  getSecurityCode(uuid: string, action: string, email: string, language: string): Observable<any> {
    console.log(language)
    let httpParams = new HttpParams().append("uuid", uuid);
    if (action != null) httpParams = httpParams.append("action", action);
    if (email != null) httpParams = httpParams.append("email", email);
    if (language != null) httpParams = httpParams.append("language", language);
    const httpOptions = {
      headers: headers,
      params: httpParams,
      responseType: 'text' as 'json'
    };

    return this.http.get<any>(SESSION_API_URL + "/code", httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  validateSecurityCode(uuid: string, code: string, language: string): Observable<any> {
    let httpParams = new HttpParams().append("uuid", uuid);
    if (code != null) httpParams = httpParams.append("code", code);
    if (language != null) httpParams = httpParams.append("language", language);
    const httpOptions = {
      headers: headers,
      params: httpParams,
      responseType: 'text' as 'json'
    };

    return this.http.get<any>(SESSION_API_URL + "/validate", httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) errorMessage = error.error.message;
    else errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    console.log(errorMessage);
    return throwError(() => { return errorMessage; });
  }

}

export class SessionData {
  uuid: string;
  time: number;
  returnUrl: string;
  expired: boolean;
  timerType: string;
}
